import { useSelector } from 'react-redux';
import { getDecisionNodeAtPath } from '../../../../../../extractFromState';
import { processConfigurableCalculationNode } from '../../Common/NodeProcessor/NodeProcessor';
import DTConfigurableNodeView from '../../DTConfigurableNodeView';

const DTConfigurableCalculationNode = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);

  return (
    <DTConfigurableNodeView
      nodeConfig={decisionNode.configurableCalculationNode}
      processHandler={processConfigurableCalculationNode}
    />
  );
};
export default DTConfigurableCalculationNode;
